import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import API from '../../Common/API';
import HomePageLoader from '../../Components/Loaders/HomePageLoader';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import useGetHomePageProducts from '../../hooks/use-get-home-page.js';
import useGetAds from '../../hooks/use-get-ads.js';
import dummyProd from '../../Assets/Images/dummyProd.jpg';

const AdCardPage = () => {
    const settings = {
        dots: false, // Disable dots
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true, // Enable autoplay
        autoplaySpeed: 5000, // Time interval (in milliseconds)
        // nextArrow: <div
        //     style={{
        //         display: "flex",
        //         justifyContent: "center",
        //         alignItems: "center",
        //         background: "blue",
        //         borderRadius: "50%",
        //         padding: "10px",
        //         zIndex: 1, // Ensure it's above the slides
        //     }}
        // >
        //     <FaArrowRightLong color="black" size={20} />
        // </div>, // Custom Next Arrow
        // prevArrow: <div
        //     style={{
        //         display: "flex",
        //         justifyContent: "center",
        //         alignItems: "center",
        //         background: "blue",
        //         borderRadius: "50%",
        //         padding: "10px",
        //         zIndex: 1, // Ensure it's above the slides
        //     }}
        // >
        //     <FaArrowLeftLong color="black" size={20} />
        // </div>
    };
    const [products, setProducts] = useState([]);
    const userDetails = useSelector((state) => state.auth.userDetails);
    const history = useHistory();
    const lang = useSelector((state) => state.theme.language);

    const { data: homeCards, isLoading } = useGetHomePageProducts();
    const { data: adsSlide } = useGetAds();

    const viewProduct = (value) => {
        history.push(`/product/${value._id}/view`);
    };

    const wishList = (value) => {
        let apiValues = {
            productId: value._id,
            addedBy: userDetails.subject._id,
        };
        API.post('/products/wishList', apiValues).then((wishRes) => {
            if (wishRes.status === 200) {
                setProducts(
                    products.map((c) => {
                        if (c._id === wishRes.data.data.productId) {
                            c.wishList = [wishRes.data.data];
                        }
                        return c;
                    })
                );
            }
        });
    };

    const getProductDisplayName = (productDetails) => {
        if (lang === 'en') {
            const { productName, brandName, modelName } = productDetails || {};
            return [productName, brandName, modelName].filter(Boolean).join(' / ');
        } else if (lang === 'ta') {
            const { tProductName, tBrandName, tModelName } = productDetails || {};
            return [tProductName, tBrandName, tModelName].filter(Boolean).join(' / ');
        } else {
            const { productName, brandName, modelName } = productDetails || {};
            return [productName, brandName, modelName].filter(Boolean).join(' / ');
        }
    };

    const homeCardAds = [
        {
            title: 'Under 499 Deals',
            redirectUrl: '/shopping/category/mobiles',
        },
        {
            title: 'Home Appliances',
            image: '/images/home-appliances.png',
            redirectUrl: '/shopping/category/home',
        },
        {
            title: "Men's Fashion",
            image: '/images/mens-fashion.png',
            redirectUrl: '/shopping/category/men',
        },
        {
            title: 'Groceries',
            image: '/images/grocery.png',
            redirectUrl: '/shopping/category/groceries',
        },
        {
            title: 'Mobiles & Accessories',
            image: '/images/mobile-category.png',
            redirectUrl: '/shopping/category/mobiles',
        },
        {
            title: 'Home Appliances',
            image: '/images/home-appliances.png',
            redirectUrl: '/shopping/category/home',
        },
        {
            title: "Men's Fashion",
            image: '/images/mens-fashion.png',
            redirectUrl: '/shopping/category/men',
        },
        {
            title: 'Groceries',
            image: '/images/grocery.png',
            redirectUrl: '/shopping/category/groceries',
        },
    ];
    return (
        <motion.div className="relative min-h-screen  w-full flex flex-row overflow-x-hidden justify-center">
            {isLoading ? (
                <HomePageLoader />
            ) : (
                <motion.div className="flex relative bg-gray-50 flex-col w-full">
                    <motion.div className="flex flex-col relative">
                        {adsSlide &&
                        adsSlide?.length &&
                        adsSlide.length === 1 &&
                        adsSlide[0]?.adsImage.length === 1 ? (
                            <div className="h-full w-full">
                                <img
                                    src={adsSlide[0]?.adsImage[0]}
                                    className="contain h-full w-full"
                                    alt={'Slide1'}
                                />
                            </div>
                        ) : (
                            <>
                                <Slider pauseOnHover={true} {...settings} className="w-full">
                                    {adsSlide &&
                                        adsSlide?.length &&
                                        adsSlide.map((c) => {
                                            return c?.adsImage?.map((slide, i) => {
                                                return (
                                                    <div className="h-full w-full">
                                                        <img
                                                            src={slide}
                                                            className="md:contain cover h-full w-full"
                                                            alt={'Slide1'}
                                                        />
                                                    </div>
                                                );
                                            });
                                        })}
                                </Slider>
                            </>
                        )}
                    </motion.div>
                    <div class="gradient-overlay"></div>
                    <motion.div
                        className="w-full absolute inset-x-0 bottom-0 px-4 md:px-20 grid grid-cols-2 sm:grid-cols-2 h-[400px] md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        {homeCards &&
                            homeCards?.homePage?.map(
                                (card, index) =>
                                    card.products.length > 0 && (
                                        <motion.div
                                            key={index}
                                            className="h-auto gap-5 px-5 py-2 w-full drop-shadow-lg bg-[white] grid grid-cols-1"
                                        >
                                            <span className="font-bold text-md py-2">
                                                {card.title}
                                            </span>
                                            <motion.div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                                                {card?.products &&
                                                    card?.products.map((product, i) => {
                                                        return (
                                                            <motion.div className="flex flex-col gap-2">
                                                                <img
                                                                    src={
                                                                        product?.images[0] ||
                                                                        dummyProd
                                                                    }
                                                                    className="object-contain h-44 w-full"
                                                                />
                                                                <span className="justify-center text-center">
                                                                    {product.productName}
                                                                </span>
                                                            </motion.div>
                                                        );
                                                    })}
                                            </motion.div>
                                            <span
                                                className="text-underline underline cursor-pointer text-[blue]"
                                                onClick={() =>
                                                    card.isPriceType
                                                        ? history.push(
                                                              `/shopping/categoryByPrice/${card.redirect}`
                                                          )
                                                        : history.push(
                                                              `/shopping/category/${card.redirect}`
                                                          )
                                                }
                                            >
                                                Shop Now
                                            </span>
                                        </motion.div>
                                    )
                            )}
                    </motion.div>
                </motion.div>
            )}
        </motion.div>
    );
};

export default AdCardPage;
